// using settings reducer to simply hold data so it doesn't have any actions currently.
import actionTypes from '../common/actionTypes';

interface State {
	questionnaireNavigationEnabled: boolean;
	selectPolicyOptionsEnabled: boolean;
	version: string | undefined;
}
const initialState = {
	questionnaireNavigationEnabled: true,
	selectPolicyOptionsEnabled: true,
	version: process.env.REACT_APP_Version,
};
export function settingsReducer(state: State = initialState, action: any) {
	switch (action.type) {
		case actionTypes.SET_QUESTIONNAIRE_NAVIGATION_ENABLED:
			return { ...state, questionnaireNavigationEnabled: action.enabled };
		case actionTypes.SET_SELECT_POLICY_OPTIONS_ENABLED:
			return { ...state, selectPolicyOptionsEnabled: action.enabled };
		default:
			return state;
	}
} 

export default settingsReducer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/settingsReducer.ts